const translations: Record<string, string> = {
  "ak_ev_total_loss_of_generation": "Total loss of generation",
  "ak_ev_no_link_collector_is_silent": "No link (collector is silent)",
  "ak_ev_partial_loss_inverters_offline": "Partial loss - inverters offline",
  "ak_ev_portfolio": "Portfolio",
};

export default translations;
